import axios from "axios";
import * as bcrypt from "bcryptjs";
import * as ApiSettingService from "../../db/serviceApiSetting";
import Account from "../../app/models/Account";
import { env } from "../../config/env";

export interface IResponseFormat {
  message: string;
  url: string;
}

const getSelectedClientId = (): string | undefined => {
  const storedClient = localStorage.getItem("Client");
  if (!storedClient) {
    return undefined;
  }

  try {
    const clientId = JSON.parse(storedClient)?.value?.id;
    return typeof clientId === "string" && clientId.length > 0
      ? clientId
      : undefined;
  } catch {
    return undefined;
  }
};

const buildShopeeConnectUrl = (
  endpoint: "/shopee/connectAccount" | "/shopee/connectAccountChat",
  reconnectId?: string
) => {
  const callbackPath = endpoint === "/shopee/connectAccount"
    ? "/shopee/auth"
    : "/shopee/authChat";
  const callbackUrl = new URL(callbackPath, env.SERVER_URL);
  const clientId = getSelectedClientId();

  if (clientId) {
    callbackUrl.searchParams.set("clientId", clientId);
  }
  if (reconnectId) {
    callbackUrl.searchParams.set("reconnectId", reconnectId);
  }

  const connectUrl = new URL(endpoint, env.SERVER_URL);
  connectUrl.searchParams.set("callbackURL", callbackUrl.toString());
  if (reconnectId) {
    connectUrl.searchParams.set("reconnectID", reconnectId);
  }

  return connectUrl.toString();
};

/* LEGACY API — replaced by src/api/server/account.tsx.
 * Manual cleanup report: remove the commented update/disconnect functions after migration.
export const updateMarketplaceInformation = async (
  accountId: string,
  data: Partial<Account>
) => {
  const url: string = env.SERVER_URL + `/marketplace/update`;
  console.log(url, "ini url edid");

  const datas = {
    accountId: accountId,
    data: data,
  };

  try {
    // get latest access token from database
    const accountAccess = await ApiSettingService.getAccess();
    if (!accountAccess) {
      console.error("Failed To Get Access Token");
      return undefined;
    }
    const token = accountAccess?.accessToken;
    console.log(token, "ini token edid");

    const response = await axios.post(url, datas, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response, "ini response edid");

    console.log("edid Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const disconnectMarketplaceChannel = async (accountId: string, channel: "erp" | "chat") => {
  const accountAccess = await ApiSettingService.getAccess();
  if (!accountAccess?.accessToken) throw new Error("Unable to authenticate marketplace disconnect");

  const response = await axios.post(
    `${env.SERVER_URL}/marketplace/${accountId}/disconnect`,
    { channel },
    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${accountAccess.accessToken}` } }
  );
  return response.data;
};
*/

export const requestLazadaURL = async (
  _marketplace: any,
  reconnect_id?: string
) => {
  const companyItem = localStorage.getItem("CompanyList");
  const client = localStorage.getItem("Client");
  let companyId = "null";
  let clientId = "null";
  if (companyItem !== null) {
    companyId = JSON.parse(companyItem).value[0].id;
  }
  if (client) {
    clientId = JSON.parse(client).value.id;
  }
  const url: string =
    env.SERVER_URL +
    `/lazada/get_auth_url?client=${clientId}&company=${companyId}&reconnect_id=${reconnect_id || ""}`;

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.post(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestLazadaChatURL = async (
  _marketplace: any,
  reconnect_id?: string
) => {
  const companyItem = localStorage.getItem("CompanyList");
  const client = localStorage.getItem("Client");
  let companyId = "null";
  let clientId = "null";
  if (companyItem !== null) {
    companyId = JSON.parse(companyItem).value[0].id;
  }
  if (client) {
    clientId = JSON.parse(client).value.id;
  }
  const url: string =
    env.SERVER_URL +
    `/lazada/get_auth_chat_url?client=${clientId}&company=${companyId}&reconnect_id=${reconnect_id || ""}`;

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.post(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestTiktokUrl = async (_marketplace: any) => {
  const url: string = env.SERVER_URL + "/tiktok/connect-erp";

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(
      `Response Get TikTok ERP URL: ${response?.data?.url}`
    );
    return response?.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestTiktokChatUrl = async (_marketplace: any) => {
  const url: string = env.SERVER_URL + "/tiktok/connect-chat";

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(
      `Response Get TikTok Chat URL: ${response?.data?.url}`
    );
    return response?.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestShopeeURL = async (_marketplace: any) => {
  const url = buildShopeeConnectUrl("/shopee/connectAccount");

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestShopeeChatURL = async (_marketplace: any) => {
  const url = buildShopeeConnectUrl("/shopee/connectAccountChat");

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestConnectShopeeURL = async (reconnect_id?: string) => {
  const url = buildShopeeConnectUrl("/shopee/connectAccount", reconnect_id);

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestConnectShopeeChatURL = async (reconnect_id?: string) => {
  const url = buildShopeeConnectUrl("/shopee/connectAccountChat", reconnect_id);

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return response.data;
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestDisconnectShopeeURL = async (
  partner_id: string,
  partner_key: string,
  app_type: string
) => {
  console.log(partner_id, "partid disconnect pkl");
  console.log(partner_key, "parkey disconnect pkl");
  const companyItem = localStorage.getItem("CompanyList");
  let companyId = "null";
  if (companyItem !== null) {
    companyId = JSON.parse(companyItem).value[0].id;
  }
  const url: string =
    env.SERVER_URL +
    `/shopee/disconnectAccount?partnerID=${partner_id}&partnerKey=${partner_key}&callbackURL=${env.SERVER_URL}/shopee/authdisconnect?appType=${app_type}&companyId=${companyId}`;

  console.log(url, "___url disconnect shopee bypass___");

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // console.log("Status from Server:", response.status);
    return partner_id && partner_key ? response.data : "";
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};

export const requestResendCodeShopeeURL = async (
  partner_id: string,
  partner_key: string
) => {
  console.log(partner_id, "partid disconnect pkl");
  console.log(partner_key, "parkey disconnect pkl");
  const url: string =
    env.SERVER_URL +
    `/shopee/generateResendCodeURL?partnerID=${partner_id}&partnerKey=${partner_key}&callbackURL=${env.SERVER_URL}/shopee/getResendCode`;

  try {
    const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Status from Server url:", response);
    return partner_id && partner_key ? response.data : "";
  } catch (error: any) {
    console.log("ERROR FROM SERVER!", error);
    return undefined;
  }
};
